import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

const ProtectedRoute = () => {
  const { state } = useAppContext();
  const location = useLocation();
  
  // Show loading spinner while checking auth
  if (state.authLoading) {
    console.log("Auth is still loading...");
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }
  
  // Only redirect after auth check is complete
  if (!state.isAuthenticated) {
    console.log("Auth check complete, not authenticated, redirecting to login");
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  console.log("Auth check complete, authenticated, rendering protected route");
  return <Outlet />;
};

export default ProtectedRoute;